export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9738.e9571e7e.jpg";